import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Dashboard from './components/Dashboard/Dashboard';
import Login from './components/Login/Login';
import Register from './components/Register/Register';
import CaseView from './components/Case/CaseView';
import ForgotPassword from './components/ForgotPassword/ForgotPassword';
import VerifyEmail from './components/VerifyEmail/VerifyEmail';

function App() {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Check for existing authentication on app load
  useEffect(() => {
    const checkExistingAuth = () => {
      const token = localStorage.getItem('jwtToken');
      const userInfo = localStorage.getItem('userInfo');

      if (token && userInfo) {
        try {
          const parsedUserInfo = JSON.parse(userInfo);
          const userData = {
            ...parsedUserInfo,
            token: token,
          };
          setUser(userData);
        } catch (error) {
          // If parsing fails, clear storage
          localStorage.removeItem('jwtToken');
          localStorage.removeItem('userInfo');
        }
      }
      setIsLoading(false);
    };

    checkExistingAuth();
  }, []);

  const handleLogin = (userData) => {
    // Store the user as-is (we assume all users are clients in this app)
    setUser(userData);
    localStorage.setItem('jwtToken', userData.token);
    localStorage.setItem('userInfo', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('userInfo');
  };

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontSize: '18px',
        }}
      >
        Loading...
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login onLogin={handleLogin} />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify" element={<VerifyEmail />} />

        {/* Protected routes */}
        <Route
          path="/dashboard"
          element={
            user ? (
              <Dashboard user={user} onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/cases/:id"
          element={
            user ? (
              <CaseView user={user} onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* Default redirect */}
        <Route path="*" element={<Navigate to={user ? '/dashboard' : '/login'} replace />} />
      </Routes>
    </Router>
  );
}

export default App;
